module.exports = __webpack_public_path__ + "static/media/google_news_badge.ffcb365d.webp";